import React, { FC } from 'react';
import { ProductType } from './PlanSelector';
import styled from 'styled-components';
import { P } from '@ovotech/element-v5';

interface Props {
  productType: ProductType;
  showKwhVariant?: boolean;
}

const StyledP = styled(P)`
  font-size: 14px !important;
  max-width: 600px;
`;

const Footnote: FC<Props> = ({ productType, showKwhVariant }) => (
  <StyledP data-testid="footnote">
    {productType === 'monthly'
      ? '¹ Mileage is calculated at a vehicle efficiency of 4 miles per kWh. Actual mileage achieved may vary depending on vehicle efficiency and driving style.'
      : showKwhVariant
      ? ''
      : '² This claim is based on driving at an average of 4 miles per kWh. Actual sum per mile is 3.5p. Individual costs will vary based on your vehicle efficiency, driving style and weather conditions.'}
  </StyledP>
);

export default Footnote;
